import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrderQuotationDialogComponent } from './work-order-quotation-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CtButtonModule, CtControlModule, CtFormModule } from '@ctsolution/ct-framework';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CtFormModule,
    CtControlModule,
    CtButtonModule,
    TranslateModule,
    MatDialogModule
  ],
  declarations: [WorkOrderQuotationDialogComponent],
  exports: [WorkOrderQuotationDialogComponent],
  providers:[{ provide: MatDialogRef, useValue: {}}]
  
  
})
export class WorkOrderQuotationDialogModule { }
